export default {
    demo: '欢迎使用本模版',
    token: '',
    summary: '',
    userInfo:{}
}